import { ref, get } from "firebase/database";
import { ReturnItemData } from "../../models/credit";
import { db } from "../firebaseConfig";

/**
 * Get Returns by Date Range
 * @param startDate : Start Date in IST
 * @param endDate : End Date in IST
 * @returns : List of returned items if found
 */
export const getReturnsByDateRange = async (
	startDate: string,
	endDate: string
): Promise<ReturnItemData[]> => {
	try {
		const returnsRef = ref(db, "returns");
		const snapshot = await get(returnsRef);
		if (!snapshot.exists()) {
			return [];
		}
		const returns = snapshot.val() as { [key: string]: ReturnItemData };
		const filteredReturns: ReturnItemData[] = [];
		Object.values(returns).forEach((returnedItem) => {
			const returnDate = returnedItem.returnDate.substring(0, 10);
			if (returnDate >= startDate && returnDate <= endDate) {
				filteredReturns.push(returnedItem);
			}
		});
		return filteredReturns;
	} catch (error) {
		console.error("Error fetching returned items by date range:", error);
		throw error;
	}
};
